import Route from "@ember/routing/route";
import { service } from "@ember/service";

export default class LoadBalancersController extends Route {
  @service availableServices;

  model() {
    let { project } = this.modelFor("organization");
    return project.hasMany("reservedIps").reload();
  }

  buildRouteInfoMetadata() {
    return { jumpable: true };
  }

  beforeModel() {
    this.availableServices.requireAccessTo(this, "networking");
  }
}
